import VideoControls from '@utils/videoControls';

export default class VisualValue {
  constructor(context) {
    if (context.querySelector('.js--video-controls')) new VideoControls(context.querySelector('.js--video-controls'), context);
  }
}
